


























import { Component, Ref, Vue } from 'vue-property-decorator';

import store, { State } from '@/store';
import { Search } from '@/data/models/search.model';
import UtenteList from './UtenteList.vue';
import UtenteFilter from './UtenteFilter.vue';
import { aclChecker } from '@/data/utils/acl';

@Component({
	components: {
		UtenteList,
		UtenteFilter
	},
})
export default class Utenti extends Vue {
	@Ref('list') list!: UtenteList;
	@Ref('filter') filter!: UtenteFilter;

	utype!: string;
	admin: boolean = false;

	state!: State;

	constructor() {
		super();
		this.state = store;
	}

	created() {
		this.utype = this.$route.meta['utype'];
		this.admin = aclChecker('role.admin');
	}

	mounted() {
		this.filter.search();
	}

	onSearch(event: Search) {
		this.list.advancedSearch = this.filterSearch(event);
		this.list.loadUtenti();
	}

	private filterSearch(search: Search) {
		search.addSimpleFilter('utype', this.utype);
		if (!this.admin) {
			search.addInFilter('userheadquarter.hid', this.state.headquarters!.map(hq => hq.id));
		}
		return search;
	}

}
